export const SECOND_NETFLIX_CAROUSEL_TEST_NAME = 'HP_BottomContentModule_March2026';
